// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z_9ld8a6hy2WjA {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.eH2UrRrebbA0pF {
  display: flex;
  justify-content: center;
}
.NEWJRjjdkp2xHv {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: 32px;
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.BJIF0XUInMNVAz {
  display: flex;
  justify-content: center;
  padding: 32px;
}
.pWPVPghMlBk2CY {
  font-style: italic;
}
.yc1kDUcLFa1RSt {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: 32px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.cNqVmAKeSWh0YE {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Z5dwBGUftr7YNx {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.Z5dwBGUftr7YNx .cwtlqGulzhm3xu {
  margin: 12px 0 0;
}
.KNcrhBq9q1eh6r {
  padding-top: 16px;
  border-top: 1px solid var(--ds-border, #091e4224);
}
.KNcrhBq9q1eh6r button {
  margin-left: 8px;
}
.XHC2VuiwoeiOod {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .yc1kDUcLFa1RSt {
    padding: 16px;
  }
}
.Z5dwBGUftr7YNx a {
  text-decoration: none;
}
.jKJZWybHvDWu0O {
  margin: 16px 0;
}
.jKJZWybHvDWu0O .acoeT_l93jRoqN {
  margin-bottom: 24px;
}
.jKJZWybHvDWu0O .JeLwLetmix2eYa {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.jKJZWybHvDWu0O .JeLwLetmix2eYa .yVmuEmhGFqrMD4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  margin-right: 16px;
  padding: 8px;
  border-radius: 4px;
  color: var(--ds-text, #172b4d);
  text-decoration: none;
  cursor: pointer;
}
.jKJZWybHvDWu0O .JeLwLetmix2eYa .yVmuEmhGFqrMD4:hover {
  background-color: var(--ds-surface-hovered, #f1f2f4);
}
.jKJZWybHvDWu0O .JeLwLetmix2eYa .yVmuEmhGFqrMD4 .AlUUeI1cPZO4FN {
  width: 64px;
  height: 64px;
  border-radius: 4px;
}
.jKJZWybHvDWu0O .JeLwLetmix2eYa .yVmuEmhGFqrMD4 .gBUAPLDS1RQFKl {
  margin-top: 8px;
  text-align: center;
  word-break: break-word;
}
.jKJZWybHvDWu0O .JeLwLetmix2eYa .yVmuEmhGFqrMD4:last-child {
  margin-right: 0;
}
.Oql9ZgsxMb70yU {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Oql9ZgsxMb70yU .APLc0BQKWZ0e3F {
  width: 370px;
  max-width: 60%;
  padding: 24px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `z_9ld8a6hy2WjA`,
	"flexAndCenter": `eH2UrRrebbA0pF`,
	"body": `NEWJRjjdkp2xHv`,
	"navigationAndContent": `BJIF0XUInMNVAz`,
	"learnMoreSubtle": `pWPVPghMlBk2CY`,
	"content": `yc1kDUcLFa1RSt`,
	"spinnerContainer": `cNqVmAKeSWh0YE`,
	"header": `Z5dwBGUftr7YNx`,
	"title": `cwtlqGulzhm3xu`,
	"footer": `KNcrhBq9q1eh6r`,
	"formFooter": `XHC2VuiwoeiOod`,
	"orgSection": `jKJZWybHvDWu0O`,
	"orgName": `acoeT_l93jRoqN`,
	"orgPowerUps": `JeLwLetmix2eYa`,
	"powerUp": `yVmuEmhGFqrMD4`,
	"powerUpIcon": `AlUUeI1cPZO4FN`,
	"powerUpName": `gBUAPLDS1RQFKl`,
	"emptyStateContainer": `Oql9ZgsxMb70yU`,
	"emptyStateImage": `APLc0BQKWZ0e3F`
};
export default ___CSS_LOADER_EXPORT___;
